import { CSSProperties } from "react";
import { Typography } from "@mui/material";
import * as CSS from "csstype";
import { TypographyVariant } from "@mui/material/styles";

interface EllipsisSpanProps {
  color?: string;
  maxWidth?: string | number;
  minWidth?: string | number;
  content?: React.ReactNode;
  textContent?: string;
  className?: string;
  style?: CSSProperties;
  variant?: TypographyVariant;
  fontWeight?: CSS.Property.FontWeight;
  fontSize?: CSS.Property.FontSize;
}

const EllipsisTextLine: React.FC<EllipsisSpanProps> = (
  {
    color,
    className,
    fontWeight,
    fontSize,
    variant,
    style,
    maxWidth,
    minWidth,
    content,
    textContent
  }) => {
  const spanStyle: React.CSSProperties = {
    maxWidth: maxWidth || "100%",
    minWidth: minWidth || 0,
    fontSize: fontSize || 'inherit',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block'
  };

  const extraStyles = style ?? {}
  return <Typography
    color={color || "text.primary"}
    fontWeight={fontWeight}
    variant={variant || "body1"}
    className={className}
    style={{ ...spanStyle, ...extraStyles }}
    title={textContent}>
    {textContent ?? content}
  </Typography>;
}

export default EllipsisTextLine;
